import React, {Component} from 'react'
import PreviewHistory from './previewHistory.jsx'
import ViewProjects from './viewProjects.jsx'
import {Link} from 'react-router-dom'

import icon_CPT from '../../images/icon_cpt.png'
import icon_ETH from '../../images/icon_eth.png'
import icon_XEM from '../../images/icon_xem.png'
import icon_PROOF from '../../images/icon_pf.png'
import icon_XYO from '../../images/icon_xyo.png'
import icon_K2G from '../../images/icon_k2g.png'
import { numberWithCommas } from '../../fiches';

import CommonFetch from '../../requests/commonFetch'

export default class Dashboard extends Component {
    constructor (props) {
        super(props)

        this.wallet = {
            CPT: icon_CPT,
            XEM: icon_XEM,
            ETH: icon_ETH,
            PROOF: icon_PROOF,
            XYO: icon_XYO,
            K2G: icon_K2G,
            K2G_C: icon_K2G,
        };

        let date = new Date();
        this.state = {
            data: {
                wallet: {
                    CPT: 0,
                    ETH: 0,
                    PROOF: 0,
                    XEM: 0,
                },
                depository: 0,
                bonus: {
                    activity: {
                        month: date.getMonth() + 1,
                        current: 0,
                        max: 2000},
                    amount: 0,
                },
                history: [
                    {
                        currency: "",
                        timestamp: 0,
                        direction: "",
                        amount: 0,
                        address: ""
                    }
                ],
            },
        }

        this.translation = JSON.parse(localStorage.translation)[localStorage.language];
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        CommonFetch({
            path: 'ui/dashboard/get_data',
            method: 'GET',
        }).then(data => {
            if (data.success) {
                let mainData = {
                    depository: data.depository,
                    bonus: data.bonus,
                    history: data.history,
                    wallet: data.wallet,
                }
                this.setState({
                    data: mainData,
                })
            } else if (data.error === 'not_logged_in') {
                this.props.exitOverdueSession()
            }
        })
    }


    render() {
        return(
            <div className="dashboard">
                <div className="dashboard_left-panel">
                        <div className="balance">
                            <h2><Link to="/investor/depository">{this.translation['Depository']}</Link></h2>
                            <hr/>
                            <p>{numberWithCommas(this.state.data.depository)} cpt</p>
                        </div>
                        <div className="preview-wallet">
                            <h2><Link to="/investor/wallet">{this.translation['Wallet']}</Link></h2>
                            <hr/>
                            <div className="wallet_currency">
                                {Object.keys(this.state.data.wallet).map(walletItem => {
                                    return (<div className="currency" key={walletItem}><img src={this.wallet[walletItem]} alt={"icon_"+walletItem}/><span>{walletItem}</span><span>{numberWithCommas(this.state.data.wallet[walletItem])}</span></div>)
                                })}
                            </div>
                        </div>
                        <PreviewHistory history={this.state.data.history}/>
                </div>
                <ViewProjects />
            </div>
        )
    }
}
